<div class="confirm-modal ig-modal export-pdf-modal">

    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div class="title">EXPORT CONTENT</div>

    <div class="pdf-modal-panel version-wrap">
        <mat-form-field>
            <mat-select [(ngModel)]="data.exportType" placeholder="File type to export">
                <mat-option value="PDF">PDF</mat-option>
                <mat-option value="CSV">CSV</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-select [disabled]="data.exportType==='CSV'" [(value)]="data.isPrintVersion"
                placeholder="Version to download">
                <mat-option matTooltip="Export the full description of the events/places" [value]="true">Print
                    version</mat-option>
                <mat-option matTooltip="Only display the summary of the events/places, and give a link for the details"
                    [value]="false">Online version</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="nav-approve-wrap">
        <div>
            <mat-radio-group class="radio-group" [(ngModel)]="data.isEvent">
                <div class="pdf-modal-panel">
                    <div class="pdf-modal-sub-panel">
                        <mat-radio-button [value]="true">
                            Download Events
                        </mat-radio-button>

                        <div style="margin-top: 1rem;">
                            <ig-date-field label="From" [(ngModel)]="data.from" [disabled]="!data.isEvent"
                                [class.enabled]="data.isEvent" [class.disabled]="!data.isEvent" [max]="data.to">
                            </ig-date-field>

                            <ig-date-field label="To" [(ngModel)]="data.to" [disabled]="!data.isEvent"
                                [class.enabled]="data.isEvent" [class.disabled]="!data.isEvent" [min]="data.from">
                            </ig-date-field>

                            <div>
                                <mat-form-field>
                                    <mat-select [disabled]="!data.isEvent" [(value)]="data.eventSource"
                                        placeholder="Events to download" (change)="sourceFilter()">
                                        <mat-option value="All">All</mat-option>
                                        <mat-option value="choice">{{editorChoice.editorChoiceForEvent}}</mat-option>
                                        <mat-option value="selected">Selected</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="pdf-modal-sub-panel">
                        <mat-radio-button [value]="false">
                            Download Places
                        </mat-radio-button>

                        <div style="margin-top: 1rem;">
                            <mat-form-field style="width: calc(100% - 32px); padding: 0 16px">
                                <mat-select [disabled]="data.isEvent" [(value)]="data.placeSource"
                                    placeholder="Places to download" (change)="sourceFilter()">
                                    <mat-option value="All">All</mat-option>
                                    <mat-option value="choice">{{editorChoice.editorChoiceForPlace}}</mat-option>
                                    <mat-option value="category">Select Places Category</mat-option>
                                    <mat-option value="selected">Selected</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <ng-container>
                                <ig-custom-default-place-category-accordion
                                    *ngIf="customDefaultPlaceCategory&&!data.isEvent&&data.placeSource==='category'"
                                    menuMode="topbar" title="Places by Categories"
                                    [toggleAndSource]="customDefaultPlaceCategory.toggle" [useNonLeafMenuClick]="true"
                                    (onCategoryClick)="selectCustomDefaultPlaceCategory($event)"
                                    (onNonLeafClick)="selectCustomDefaultPlaceCategory($event)"
                                    (onNormalCategoryClick)="selectCustomDefaultPlaceCategory($event)"
                                    [customDefaultPlaceCategory]="customDefaultPlaceCategory">
                                </ig-custom-default-place-category-accordion>
                            </ng-container>

                            <mat-form-field style="width: calc(100% - 32px); padding: 0 16px" *ngIf="data.exportType==='CSV'">
                                <mat-select [disabled]="data.isEvent" [(value)]="data.approvalStatus"
                                    placeholder="Approval Status" (change)="sourceFilter()">
                                    <mat-option value="all">All</mat-option>
                                    <mat-option value="approved">Approved</mat-option>
                                    <mat-option value="unapproved">Unapproved</mat-option>                                    
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

            </mat-radio-group>
        </div>
    </div>

    <ig-row [pinCenter]="true">
        <ig-col [xs]="6">
            <ig-button style="display: inline-block;" class="btn-primary" #confirmButton color="primary" size="md"
                [isAsync]="data.isAsync" (trigger)="confirm($event)">
                Download Content
            </ig-button>
            <span *ngIf="data.exportType==='PDF'">{{progress}}</span>
        </ig-col>
    </ig-row>
    <div class="cancel-btn" *ngIf="!confirmButton.isLoading" (click)="close()">
        Cancel
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/export.pdf.modal/export.pdf.modal.component.html